/* eslint-disable jsx-a11y/control-has-associated-label */
import React from 'react';
import { TutorialVideoModal } from './TutorialVideoModal';
import { getYoutubeThumbnail } from './utils';

interface Props {
  youtubeURL: string;
  tutorialDuration: string;
  onClick?: () => void;
}

export const TutorialVideo: React.FC<Props> = ({ youtubeURL, tutorialDuration, onClick }) => {
  const [modalOpen, setModalOpen] = React.useState(false);

  const handleClick = () => {
    onClick?.();
    setModalOpen(true);
  };

  return (
    <>
      <TutorialVideoModal
        open={modalOpen}
        youtubeUrl={youtubeURL}
        onClose={() => setModalOpen(false)}
      />
      <div
        className="rounded-lg overflow-hidden relative cursor-pointer"
        style={{ width: '176px', height: '99px' }}
        onClick={handleClick}
      >
        <img
          width="100%"
          height="auto"
          style={{
            margin: '-16px 0',
            filter: 'grayscale(70%)',
          }}
          src={getYoutubeThumbnail(youtubeURL) || ''}
          alt="tutorial video"
        />
        <button
          className="absolute"
          type="button"
          style={{
            border: 0,
            background: 'transparent',
            boxSizing: 'border-box',
            width: 0,
            height: '23px',
            borderColor: 'transparent transparent transparent white',
            transition: '100ms all ease',
            cursor: 'pointer',
            borderStyle: 'solid',
            borderWidth: '12px 0 12px 15px',
            top: '35%',
            left: '50%',
          }}
        />
        <h6 className="text-white absolute" style={{ right: '10px', bottom: '5px' }}>
          {tutorialDuration}
        </h6>
      </div>
    </>
  );
};
